import { render, staticRenderFns } from "./MessageGroupOverlay.vue?vue&type=template&id=89525898&scoped=true&"
import script from "./MessageGroupOverlay.vue?vue&type=script&lang=js&"
export * from "./MessageGroupOverlay.vue?vue&type=script&lang=js&"
import style0 from "./MessageGroupOverlay.vue?vue&type=style&index=0&id=89525898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89525898",
  null
  
)

export default component.exports